import type { FC, ReactNode } from 'react';

import { CommunityMemberActionsProvider } from './CommunityMemberActionsProvider';
import { CommunityPostActionsProvider } from './CommunityPostActionsProvider';

// Single mount point for the community action providers.
export const CommunityActionsProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <CommunityMemberActionsProvider>
    <CommunityPostActionsProvider>{children}</CommunityPostActionsProvider>
  </CommunityMemberActionsProvider>
);
